'use strict';

var React = require('react/addons'),
    PropTypes = React.PropTypes,
    {t} = require('services/i18nextWrapper'),
    {kebabCase} = require('lodash/string'),
    BasicForm,
    Notification = require('components/Notification/Notification');

/**
 * The base class Form that make a contract that will need to stick all his child's component in
 * order to be use them.
 */
BasicForm = {

    propTypes: {

        /**
         * The current object of form. If `value` is defined means the form is to change.
         * Otherwise means that is a new form.
         *
         */
        value: PropTypes.object,

        /**
         * Trigger fetch items from the parent admin consumer.
         */
        fetchItems: PropTypes.func.isRequired,

        /**
         * The name of item that handler this form.
         */
        itemName: PropTypes.string.isRequired,

        /**
         * The title of the form
         */
        title: PropTypes.string,

        /**
         * Assure that the children element are that we expected.
         * @param props
         * @param propName
         * @param componentName
         */
        children(props, propName) {
            var fields = props[propName];
            React.Children.forEach(fields, function (child) {
                if (kebabCase(child.type.displayName).indexOf('form-group') === -1) {
                    throw new Error('The children must be a `form-group` component.');
                }
            });
        }
    },

    /**
     * Generic ajax error notification.
     */
    onFailure() {
        Notification.show(t('dashboard_notification_error_try_again'), 'error');
    }

};

module.exports = BasicForm;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/BasicForm.jsx
 **/